import { create } from "zustand";
import type { AgfStreamingPoint, AgfTvHitlisteRow, AgfTvMarktanteilRow, FfaKinoOverview } from "@/lib/tobis-market";

// Der geladene Stand des Markt-Dashboards - dasselbe Prinzip wie
// tobis-register-store (Titel) und tobis-talent-store (Personen): ein Store
// statt useState, damit ein Zurueck von einer anderen Tobis-Seite nicht die
// drei Marktabfragen (FFA/AGF/AGF-TV) neu laedt. Kein Filter-/Sortierstand
// hier - die Seite hat keine Server-Filter, alle Auswahlen (Zielgruppen,
// Kennzahlen-Suche, ...) sind reine Client-Ansichtspraeferenzen auf den schon
// geladenen Daten und bleiben deshalb lokaler useState in TobisMarketPage.
//
// Bewusst NICHT persistiert (localStorage) - derselbe Grund wie bei den
// anderen beiden Registern: der Bestand aendert sich mit jedem Ingest-Lauf,
// der Stand soll eine Sitzung ueberleben, nicht einen Neustart.

interface TobisMarketState {
  ffa: FfaKinoOverview | null;
  agf: AgfStreamingPoint[] | null;
  agfTvHitliste: AgfTvHitlisteRow[];
  agfTvMarktanteil: AgfTvMarktanteilRow[];
  /** Ob die obigen Felder zum aktuellen Stand gehoeren - wie bei den anderen Registern die einzige Stelle, die "muss ich laden?" entscheidet. */
  loaded: boolean;

  setData: (
    ffa: FfaKinoOverview,
    agf: AgfStreamingPoint[],
    agfTvHitliste: AgfTvHitlisteRow[],
    agfTvMarktanteil: AgfTvMarktanteilRow[],
  ) => void;
  markLoaded: () => void;
}

export const useTobisMarketStore = create<TobisMarketState>((set) => ({
  ffa: null,
  agf: null,
  agfTvHitliste: [],
  agfTvMarktanteil: [],
  loaded: false,

  setData: (ffa, agf, agfTvHitliste, agfTvMarktanteil) =>
    set({ ffa, agf, agfTvHitliste, agfTvMarktanteil, loaded: true }),
  markLoaded: () => set({ loaded: true }),
}));
